import { JsonForms } from '@jsonforms/react';
import { usePresetContext } from '../contexts/PresetContext';
import { createAjv, JsonFormsCore } from '@jsonforms/core';
import { mantineCells, mantineRenderers } from '../renderers';
import { Fieldset, Text, Alert, Group } from '@mantine/core';
import uischema from '@/app/schema/uiSchema.json';
import { ExportSettings } from './ExportSettings';
import { originSchema } from '../constants/schema';
import { useCallback, useMemo } from 'react';
import { IconAlertTriangle } from '@tabler/icons-react';

export const Form = () => {
  const handleDefaultsAjv = useMemo(() => createAjv(), []);

  const { formData, setFormData } = usePresetContext();

  const handleChange = useCallback(
    ({ data, errors }: Pick<JsonFormsCore, 'data' | 'errors'>) => {
      // console.log('Form data', data);
      // console.log({ errors });
      setFormData(data);
    },
    [setFormData]
  );

  const hasVrm = useMemo(() => {
    if (!formData?.export || !Array.isArray(formData.export)) return false;
    return formData.export.some(item => item.format?.vrm);
  }, [formData]);

  return (
    <Fieldset
      w='100%'
      h='900'
      pr='sm'
      style={(theme) => ({
        border: 'none',
        borderLeft: `1px solid ${theme.colors.gray[3]}`,
        overflow: 'auto',
      })}
    >
      {hasVrm && (
        <Alert
          icon={<IconAlertTriangle size="1rem" />}
          title="VRM Export Warning: VRM exports are only supported for VRM input files"
          color="grey"
        >
        </Alert>
      )}
      <JsonForms
        schema={originSchema}
        data={formData}
        renderers={mantineRenderers}
        cells={mantineCells}
        onChange={handleChange}
        ajv={handleDefaultsAjv}
        config={{ uischema }}
      />
      <ExportSettings />
    </Fieldset>
  );
};
